<template>
  <v-card flat>
    <v-tabs
      fixed-tabs
      background-color="primary"
      show-arrows
    >
      <v-tab>
        PERSONAL INFORMATION
      </v-tab>
      <v-tab>
        ENTERPRISE INFORMATION
      </v-tab>
      <v-tab>
        LOCATION/FARM INFORMATION
      </v-tab>
      <v-tab-item>
        <v-card flat color="background">
          <v-row class="ma-0" justify="center">
            <v-col
              cols="12"
              md="4"
            >
              <v-card>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Bio
                </div>
                <v-row>
                  <v-col class="pa-6" cols="12" align="center">
                    <v-card class="image-card">
                      <v-img
                      :src= "`http://localhost:5000/${farmers.photo}`"
                      class="image-card"
                    ></v-img>
                    </v-card>
                  </v-col>
                </v-row>
                <v-form>
                  <v-container class="px-4">
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmers.first_name"
                          label="First Name"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmers.last_name"
                          label="Last Name"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              md="8"
            >
              <v-card>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Identity
                </div>
                <v-form>
                  <v-container class="px-4">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          label="Registration No"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmers.identification.id_type"
                          label="Type of Identification"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmers.identification.number"
                          label="Identification Number"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.next_of_kin"
                          label="Next of Kin"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.edu_qua"
                          label="Education Qualification"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmers.phone"
                          label="Phone"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmers.age"
                          label="Age"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmers.gender"
                          label="Gender"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <div class="h2 pt-4 font-weight-bold">
                      Address
                    </div>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmers.village"
                          label="Village"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmers.state"
                          label="State"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="farmers.lga"
                          label="Lga"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-combobox
                          v-model="farmers.challenges"
                          label="Challenges"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <!--entrprise information///////////////////////-->
      <v-tab-item>
        <v-card flat color="background">
          <v-row class="ma-0">
            <v-col
              cols="12"
            >
              <v-card>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Enterprise Information
                </div>
                <v-form>
                  <v-container class="px-4">
                    <h4 class="py-1">Crop Information</h4>
                    <v-row
                      v-for="(crop, k) in farmers.crops"
                      :key="k"
                    >
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="crop.type"
                          label="Crop Type"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="crop.size"
                          label="Crop Size"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="crop.year_harvest_estimate"
                          label="Harvest Estimate"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="crop.planting_season"
                          label="Planting Season"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="crop.harvest_season"
                          label="Harvest Season"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <!--livestock -------->
                    <h4 class="py-1">Livestock Information</h4>
                    <v-row
                      v-for="(livestock, l) in farmers.livestocks"
                      :key="livestock+l"
                    >
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="livestock.type"
                          label="Crop Type"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="livestock.size"
                          label="Crop Size"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="livestock.year_harvest_estimate"
                          label="Harvest Estimate"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="livestock.planting_season"
                          label="Planting Season"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="livestock.harvest_season"
                          label="Harvest Season"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <!--fishery -----====----->
                    <h4 class="py-1">Fishery Information</h4>
                    <v-row
                      v-for="(fish, m) in farmers.fishery"
                      :key="'fish'+m"
                    >
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="fish.type"
                          label="Crop Type"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="fish.size"
                          label="Crop Size"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="fish.year_harvest_estimate"
                          label="Harvest Estimate"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="fish.stocking_season"
                          label="Planting Season"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="2"
                      >
                        <v-text-field
                          v-model="fish.harvest_season"
                          label="Harvest Season"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Other Information
                </div>
                <v-form>
                  <v-container class="px-4">
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-combobox
                          v-model="farmers.input_source"
                          label="Input source"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-combobox
                          v-model="farmers.processing"
                          label="Processing"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-combobox
                          v-model="farmers.market"
                          label="Market"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-combobox
                          v-model="farmers.farming_types"
                          label="Farming Types"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
            <!--others-/////////////////////////////////////////////////-->
          </v-row>
        </v-card>
      </v-tab-item>
      <!--farm information//////////////////////////-->
       <v-tab-item>
        <v-card flat color="background">
          <v-row class="ma-0">
            <v-col
              cols="12"
              md="8"
            >
              <v-card>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Location/Farm Info
                </div>
                <v-form>
                  <v-container class="px-4">
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.farm_address"
                          label="Farm Address"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.plot_gps"
                          label="Plot GPS"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.farm_lga"
                          label="Farm Lga"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.farm_village"
                          label="Farm Village"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.no_male_emp"
                          label="Male Emp"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.no_female_emp"
                          label="Female Employee"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.avg_emp_age"
                          label="Avg Employee Age"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.soil_condition"
                          label="Soil Condition"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                     <div class="h2 pt-4 font-weight-bold">
                      Financial Information
                    </div>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.business_name"
                          label="Business Name"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.bank_name"
                          label="Bank Name"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.account_name"
                          label="Account Name"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="farmers.account_num"
                          label="Account Number"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
            <!--others-/////////////////////////////////////////////////-->
            <v-col>
              <v-card>
                <div class="h2 px-4 pt-4 font-weight-bold">
                  Other Information
                </div>
                <v-form>
                  <v-container class="px-4">
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmers.corpo_assos"
                          label="Corperative society"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmers.avg_monthly_income"
                          label="Avg Monthly Income"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="farmers.insurance_cover"
                          label="Insurance Cover?"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-combobox
                          v-model="farmers.funding"
                          label="Funding"
                          outlined
                          chips
                          multiple
                          append-icon=""
                        >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
// import FarmerService from '../services/FarmerService'

export default {
  name: 'Farmer',
  data () {
    return {
      farmers: {
        first_name: '',
        last_name: '',
        phone: '',
        next_of_kin: '',
        states: '',
        lga: '',
        village: '',
        age: '',
        gender: '',
        edu_qua: '',
        family_size: '',
        identification: {
          type: '',
          number: ''
        },
        photo: '',

        // Enterprise Information
        crops: [
          {
            type: '',
            size: '',
            year_harvest_estimate: '',
            planting_season: '',
            Harvest_season: ''
          }
        ],
        livestocks: [
          {
            type: '',
            size: '',
            year_harvest_estimate: '',
            planting_season: '',
            Harvest_season: ''
          }
        ],
        fishery: [
          {
            type: '',
            size: '',
            year_harvest_estimate: '',
            planting_season: '',
            Harvest_season: ''
          }
        ],
        input_source: [],
        processing: [],
        planting_season: '',
        year_harvest_estimate: '',
        harvest_season: '',
        market: [],

        // financial information
        business_name: '',
        bank_name: '',
        account_name: '',
        account_num: '',
        insurance_cover: '',
        farming_types: [],
        funding: [],
        avg_monthly_income: '',

        // Location/ Farm
        farm_address: '',
        farm_lga: '',
        farm_village: '',
        no_male_emp: '',
        no_female_emp: '',
        corpo_assos: '',
        avg_emp_age: '',
        plot_gps: '',

        // Others
        challenges: []
      },
      loading: false
    }
  }
  /* async created () {
    this.loading = true
    const id = this.$route.params.id
    this.farmers = await FarmerService.getFarmer(id)
    this.loading = false
  } */
}
</script>

<style lang="scss" scoped>
.image-card{
  max-height: 300px;
  max-width: 300px
}
@media(max-height: 640px) {
  .image-card{
    height: 250px;
    width: 250px
  }
}
@media(max-height: 740px) and (min-height: 641px) {
  .image-card{
    height: 250px;
    width: 250px
  }
}
@media(max-height: 840px) and (min-height: 741px) {
  .image-card{
    height: 300px;
    width: 300px
  }
}
</style>
